import RestClientV1 from "./RestClientV1";
import RestClientV2 from "./RestClientV2";
import rsql from "./rsql"

const packageSeparator = '_';

export { RestClientV1, RestClientV2, rsql, packageSeparator }


// WEBPACK FOOTER //
// ./src/main/javascript/modules/rest-client/index.js